export const getPaginationItems = (currentPage, totalPages) => {
  const pages = [];

  if (totalPages <= 1) return [1];

  pages.push(1);

  if (currentPage > 3) {
    pages.push("...");
  }

  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(totalPages - 1, currentPage + 1);
    i++
  ) {
    pages.push(i);
  }

  if (currentPage < totalPages - 2) {
    pages.push("...");
  }

  if (totalPages > 1) {
    pages.push(totalPages);
  }

  return pages;
};


// Get showing range (e.g. Showing 1 to 10 of 100)
export const getShowingRange = (currentPage, perPage, totalItems) => {
  const start = Math.min((currentPage - 1) * perPage + 1, totalItems);
  const end = Math.min(currentPage * perPage, totalItems);

  return { start, end };
};